var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var JobRegistry_1;
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { name as JobDispatcherName } from './jobDispatcher';
import { name as CookieJobStorageDriverName } from './cookieJobStorageDriver';
/** Name of this module */
export const name = 'JobRegistry';
let JobRegistry = JobRegistry_1 = class JobRegistry {
    constructor(jobStorage, dispatcher) {
        this.jobStorage = jobStorage;
        this.dispatcher = dispatcher;
    }
    static create({ jobStorage, dispatcher }) {
        return new JobRegistry_1(jobStorage, dispatcher);
    }
    /**
     * Dispatch our job if playable
     * @param job The job we want to publish
     */
    add(job) {
        // Filter out all duplicate jobs with topic
        const duplicateJobs = this.jobStorage
            .retrieveJobsByTopic(job.getTopic())
            .filter(found => job.isDuplicate(found));
        // Return if duplicate jobs found
        if (duplicateJobs.length > 0) {
            return;
        }
        this.dispatcher.dispatchJob(job);
        if (job.isDurable()) {
            this.jobStorage.persistJob(job);
        }
    }
};
JobRegistry = JobRegistry_1 = __decorate([
    injectable({
        key: name,
        scope: InjectorScope.Singleton,
        dependencies: {
            ...Injector.createDependency(CookieJobStorageDriverName, InjectorScope.Singleton),
            ...Injector.createDependency(JobDispatcherName, InjectorScope.Singleton),
        },
    })
], JobRegistry);
export default JobRegistry;
